import { render, staticRenderFns } from "./MoleculeEditionAssetSignedStudentsModalCreate.vue?vue&type=template&id=5d530d90&"
import script from "./MoleculeEditionAssetSignedStudentsModalCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetSignedStudentsModalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports